import { render, staticRenderFns } from "./NotificationListPage.vue?vue&type=template&id=778dbb96&scoped=true&"
import script from "./NotificationListPage.vue?vue&type=script&lang=js&"
export * from "./NotificationListPage.vue?vue&type=script&lang=js&"
import style0 from "./NotificationListPage.vue?vue&type=style&index=0&id=778dbb96&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778dbb96",
  null
  
)

export default component.exports